import React from 'react';
import './CompanyStory.css';
import Company from '../../../Gemco-Website-Images/About-Us/mechanical-room.jpg';

const CompanyStory = () => {
  return (
    <div className='wp_company_story_wrap'>
        <div className="container wp_company_story_content">
            <div className="wp_company_story_text">
                <h1>Our Story</h1>
                <p>"Gandhi Electro Mechanical Co. LLC (GEMCO) has been delivering specialist
                    MEP works in the UAE since 1996. What began as precision installation
                    expertise — built across district cooling plants, data centers, airports, and
                    luxury hotels — has evolved into a full MEP supply and installation capability
                    trusted on some of the UAE's most prestigious ongoing projects. Today we
                    work both as specialist partners to the region's leading MEP contractors and
                    directly for developers, asset owners, and facility managers who demand
                    reliability, technical depth, and a team that treats every project as their most
                    important one."</p>
            </div>
            <div className="wp_company_story_image">
                <img src={Company} alt="mechanical room" />
            </div>
        </div>
    </div>
  )
}

export default CompanyStory